import React, { memo, useCallback } from 'react';
import * as S from './DesktopHeaderCategories.styles';
import { DesktopHeaderCategoriesProps } from './DesktopHeaderCategories.types';
import { useDesktopCatalogueStore } from '@/store/useDesktopCatalogueStore';
import { CustomLink } from '@/components/CustomLink/CustomLink';

export const DesktopHeaderCategories = memo(
  ({
    items,
    selectedItemId,
    onSelect,
    isFirstColumn,
  }: DesktopHeaderCategoriesProps) => {
    const [toggleDesktopCatalogue] = useDesktopCatalogueStore(state => [
      state.toggleDesktopCatalogue,
    ]);

    const onMouseEnter = useCallback(
      (id: string) => () => onSelect(id),
      [onSelect]
    );

    return (
      <S.DesktopHeaderCategoryItems $isFirstColumn={isFirstColumn}>
        {items.map(({ id, path, name, hasDecendants, iconSrc }) => (
          <S.DesktopHeaderCategoryItem
            key={id}
            as={CustomLink}
            href={path}
            onClick={toggleDesktopCatalogue}
            $isSelected={selectedItemId === id}
            onMouseEnter={onMouseEnter(id)}
          >
            {iconSrc && <S.DesktopHeaderCategoryIcon $src={iconSrc} />}
            <S.DesktopHeaderCategoryLabel $isFirstColumn={isFirstColumn}>
              {name}
            </S.DesktopHeaderCategoryLabel>
            {hasDecendants && (
              <S.DesktopHeaderCategoryAngleIcon
                $isFirstColumn={isFirstColumn}
              />
            )}
          </S.DesktopHeaderCategoryItem>
        ))}
      </S.DesktopHeaderCategoryItems>
    );
  }
);

DesktopHeaderCategories.displayName = 'DesktopHeaderCategories';
